import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto;
`

export const CardGroup = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 3rem;
  @media (max-width: 769px) {
        flex-wrap: wrap;
        justify-content: space-around;
  }
  @media (max-width: 1400px) {
        flex-wrap: wrap;
        justify-content: space-around;
  }
`;

export const SeachInput = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 1rem;
`;

export const ImgSearch = styled.img`
  padding-bottom: 1rem;
  width: 5rem;
`;

export const TextSearch = styled.p`
  font-size: 1.5rem;
  color: var(--thirdBlue);
  justify-self: center;
`;

export const InputSearch = styled.div`
  border-radius: 2.5rem;
  border: 2px solid var(--mainBlue);
  padding-left: 1rem;
  padding-right: 1rem;
  margin-left: 0.5rem;
  margin-right: 0.2rem;
  outline-color: var(--mainBlue);
  width: 20rem;
  transition: 1s;
  &:focus{
    border: var(--thirdBlue);
  }
  @media (max-width: 769px) {
    width: 10rem;
  }
`;

export const BtnSearch = styled.button`
	background: var(--mainBlue);
  color: var(--thirdBlue);
  border: solid var(--mainBlue);
  padding: 0.2em 0.3em;
  font-size: 1em;
  transition: color 0.25s, border-color 0.25s, box-shadow 0.25s, transform 0.25s;
  border-radius: 70%;

  &:hover{
    border-color: var(--secondBlue);
    color: var(--secondBlue);
    box-shadow: 0 0.5em 0.5em -0.4em var(--mainShadow);
    cursor: pointer;
  }
  &:active{
    transform: scale(0.9);
  }
`;

export const HeroContent = styled.div`
  display: flex;
  padding-top: 2rem;
  flex-wrap: wrap;
  margin:2.5rem;
  justify-content: space-around;
  @media (max-width: 769px) {
    width: 95%;
    justify-content: space-between;
  }
  @media (max-width: 1080px) {  
    margin: 0.5rem;
    justify-content: space-between;
  }
  
`;

export const MainTitle = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  margin-bottom: 32px;
`;

export const MainRegion = styled.span`
  color: #1E3A8A;
  text-decoration: underline;
`;